import { defineStore } from 'pinia';
import { reactive, watch, ref } from 'vue';
import {
    useCollection,
    useDocument,
    useFirestore
} from 'vuefire'
import {
    collection,
    query,
    where,
    doc,
    orderBy,
    limit
} from 'firebase/firestore'
const storeName = 'db'
export default defineStore(storeName, () => {
    const stateData = reactive({
        initialized: false,
        completed: false,
        inventory: [],
        inventoryPending: true,
        inboundShipments: [],
        inboundShipmentsPending: true,
        inboundShipmentsArchive: [],
        inboundShipmentsArchivePending: true,
        outboundShipments: [],
        outboundShipmentsPending: true,
        requests: [],
        requestsPending: true,
        events: [],
        eventsPending: true,
        user: {},
        userPending: true,
        platform: {},
        platformPending: true
    })
    
    const initialize = async (uid) => {
        const db = useFirestore();
        stateData.initialized = true;

        // Bind a query and surface rules/index failures with the collection name instead of
        // an anonymous unhandled rejection. On failure the binding resolves to empty so the
        // app keeps working and the "completed" watcher isn't stuck on a pending flag.
        const bind = (key, useFn, source, empty) => {
            const { data, pending, promise } = useFn(source)
            stateData[key] = data
            stateData[`${key}Pending`] = pending
            // vuefire exposes `promise` as a ref wrapping the underlying promise
            const p = promise && typeof promise.then === 'function' ? promise : promise?.value
            if (p && typeof p.catch === 'function') {
                p.catch((err) => {
                    console.warn(`[db] ${key} unavailable:`, err?.code || err?.message || err)
                    stateData[key] = empty
                    stateData[`${key}Pending`] = false
                })
            }
        }

        bind('inventory', useCollection, query(collection(db, 'inventory'), where('owner', '==', uid)), [])
        bind('inboundShipments', useCollection, query(collection(db, 'inbound_shipments'), where('owner', '==', uid)), [])
        bind('inboundShipmentsArchive', useCollection, query(collection(db, 'inbound_shipments_archive'), where('owner', '==', uid)), [])
        bind('outboundShipments', useCollection, query(collection(db, 'outbound_shipments'), where('owner', '==', uid)), [])
        bind('requests', useCollection, query(collection(db, 'requests'), where('owner', '==', uid)), [])
        bind('events', useCollection, query(collection(db, 'events'), where('owner', '==', uid), orderBy('created'), limit(10)), [])
        bind('user', useDocument, doc(db, 'users', uid), {})
        // 'platform/external' was bound here but is never read anywhere in the app; removed.
        stateData.platformPending = false
    }
    watch(() => stateData, (state) => {
        if (!state.inventoryPending && !state.inboundShipmentsPending && !state.inboundShipmentsArchivePending && !state.outboundShipmentsPending && !state.requestsPending && !state.eventsPending && !state.userPending && !state.platformPending) {
            stateData.completed = true;
        }
    }, { deep: true })
    return {
        stateData,
        initialize
    }
})
